import { render, staticRenderFns } from "./ConsignmentDetails/ConsignmentDetails.html?vue&type=template&id=5a617398&scoped=true&external"
import script from "./ConsignmentDetails.vue?vue&type=script&lang=js"
export * from "./ConsignmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentDetails.vue?vue&type=style&index=0&id=5a617398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a617398",
  null
  
)

export default component.exports